import { siteContent } from "../../content/siteContent";

export function Method() {
  const { method } = siteContent;

  return (
    <section id={method.id} className="home-method home-section" aria-labelledby="home-method-title">
      <div className="home-shell">
        <div className="home-section-intro home-method__intro">
          <p className="home-eyebrow">{method.eyebrow}</p>
          <h2 id="home-method-title" className="home-editorial-heading">
            {method.title}
          </h2>
          <p className="home-section-intro__text">{method.intro}</p>
        </div>

        <ol className="home-method__steps">
          {method.steps.map((step) => (
            <li key={step.number} className="home-method__step">
              <span className="home-method__number" aria-hidden="true">
                {step.number}
              </span>
              <h3>{step.title}</h3>
              <p>{step.text}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
